// ABOUTME: MSAL authentication configuration for legacy-market space
// ABOUTME: Uses Azure AD B2C for legacy market authentication
import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object for legacy market MSAL instance with Azure AD B2C
export const legacyMsalConfig: Configuration = {
    auth: {
        authority: 'https://factorlabsb2cdemo.b2clogin.com/f0218a14-09b5-4231-a1b7-cf8bd0c08290/B2C_1A_MIGRATION_SUSI',
        clientId: 'e6037590-1865-4234-a269-000e47ab6510', // TODO: Replace with actual legacy market client ID
        redirectUri: window.location.origin + '/legacy-market',
        knownAuthorities: ["factorlabsb2cdemo.b2clogin.com"],
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

// Scopes for legacy market id token
export const legacyLoginRequest: PopupRequest = {
    scopes: ["openid"],
};

// API endpoints for legacy market (if using custom APIs)
export const legacyApiConfig = {
    apiEndpoint: "https://api.factorlabs.pl/legacy", // TODO: Replace with actual API endpoint
};
